import React from 'react';
import 'twin.macro';
import useSequencesFolders from 'queries/sequences/useSequencesFolders';
import { FolderContent } from 'containers/Sequences/FolderContent/FolderContent';
import { ItemsList } from 'components/ItemsList';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FDPIllustration } from './SequencesIllustrations';

export function Home() {
  const { data, isLoading } = useSequencesFolders();
  const { t } = useTranslation(['common', 'sequence']);
  const navigate = useNavigate();

  if (isLoading) {
    return null;
  }

  if ((data || []).length === 0) {
    return (
      <ItemsList
        title={t('sequence:list.titles.mySequences')}
        newTitle={t('sequence:list.messages.welcome')}
        newDescription={t('sequence:list.messages.createInstructions')}
        newButtonCtaLabel={t('sequence:list.actions.startNewSequence')}
        illustration={<FDPIllustration />}
        items={[]}
        onClickItem={() => {}}
        onAddItem={() => navigate('/sequences/new')}
        Actions={() => null}
      />
    );
  }
  return (
    <FolderContent
      home
      folder={{
        id: 'root',
        type: 'folder',
        title: '',
        children: data,
      }}
    />
  );
}
